import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VToolbar,{staticClass:"mb-4"},[_c(VToolbarTitle,[_vm._t("default")],2),_c(VSpacer),_c(VToolbarItems,[_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }